import React from 'react'

import {
    BrowserRouter as Router,
    Route,
    Routes,    
    Navigate
} from "react-router-dom";
import HomePage from './pages/Home/HomePage';
import PoliticaDePrivacidade from './pages/PoliticaDePrivacidade';
import SocialMedia from './pages/SocialMedia';
import CentralDeInformacoesEtiquetas from './pages/CentralDeInformacoesEtiquetas';
import ManualEcommerce from './pages/ManualEcommerce';

const AppRoutes = () => {        
    return(
        <Router basename={process.env.PUBLIC_URL}>          
            <Routes>                             
              <Route
                path="/"
                element={<Navigate to="/home" />}
              />        
              <Route exact path="/home" element={<HomePage />} />  
              <Route exact path="/politica-de-privacidade" element={<PoliticaDePrivacidade />} />
              <Route exact path="/contato" element={<SocialMedia />} />            
              <Route exact path="/central-de-informacoes/etiquetas" element={<CentralDeInformacoesEtiquetas />} />            
              <Route exact path="/central-de-informacoes/manualecommerce" element={<ManualEcommerce />} />                                  
            </Routes>                            
      </Router>
    )
}
export default AppRoutes;